// Campaign types the backoffice has no views for. They are hidden from /campaigns, and nothing
// should link to /campaigns/<type> for them either.
export const UNSUPPORTED_CAMPAIGN_TYPES: ReadonlySet<string> = new Set([
  'combo',
  'loyaltyprize',
  'loyaltydiscount',
  'crosssell',
  'lunchcombo',
  'loyaltyreward',
  'fixedpricecombo',
  'fixedpricebundle',
]);

// The API types campaignCategory as a string enum, but campaigns saved without a category come back
// as the number 0.
export const normalizeCampaignCategory = <T extends { campaignCategory?: unknown }>(campaign: T): T =>
  (campaign.campaignCategory as unknown) === 0 ? { ...campaign, campaignCategory: undefined } : campaign;
